import { usePartnerId, useRetailerId } from '../../../../utils/routing/params.hooks'
import { useGetStoreGroupsByRetailerQuery } from '../../../../__codegen__/api'

export interface StoreGroup {
  id: string
  name: string
  retailerLocationIds: string[]
}

export const useSearchStoreGroups = () => {
  const partnerId = usePartnerId()
  const retailerId = useRetailerId()

  const { data, error, loading, refetch } = useGetStoreGroupsByRetailerQuery({
    variables: {
      partnerId,
      retailerId: retailerId != null && retailerId !== '0' ? retailerId : undefined,
    },
  })

  const storeGroups: StoreGroup[] = (data && data.retailerLocationGroupsByRetailer.nodes) || []

  return {
    storeGroups,
    loading,
    error,
    refetch,
  }
}
